import type { ContactSaveRequest } from '@highereducation/prospect';
import type { SaveContactParams } from '@de/types';

type ProspectTrackingContext = NonNullable<
  ContactSaveRequest['contact']['trackingContext']
>;

/**
 * Maps browser Cohesion context and DE contact params to Prospect Service
 * `contact.trackingContext`. Hub derives `cohesionSessionId` from `sessionId`.
 */
export function buildProspectTrackingContext(
  data: SaveContactParams,
): ProspectTrackingContext {
  const cohesionWebContext =
    typeof window !== 'undefined' ? window._Cohesion?.webContext : undefined;

  const publisher =
    data.publisher?.trim() ||
    (typeof window !== 'undefined' && window.HE?.publisher?.name) ||
    (typeof window !== 'undefined' && window.location?.host) ||
    '';

  return {
    ...(cohesionWebContext ?? {}),
    sessionId: data.cohesionSessionId,
    publisher,
  };
}
